import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http';

const state: ServicePaymentState = {
  activeServicePayment: null,
  paymentIntent: null,
};

const getters: GetterTree<ServicePaymentState, RootState> = {};

const actions: ActionTree<ServicePaymentState, RootState> = {
  newPaymentIntent(_, { object_id, payload }) {
    return http.v1.sp.newPaymentIntent(object_id, payload);
  },
  preCalculatePrice({ commit }, payload) {
    return http.v1.sp
      .preCalculatePrice(payload)
      .then((response) => {
        if (response.data.data.service_payment) {
          if (response.data.data.service_items) {
            response.data.data.service_payment['service_items'] =
              response.data.data.service_items;
          }
          commit(
            'SET_ACTIVE_SERVICE_PAYMENT',
            response.data.data.service_payment
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  invoice(_, oid) {
    return http.v1.sp.invoice(oid);
  },
  fetch({ commit }, { oid, params }) {
    return http.v1.sp
      .fetch(oid, { params: params })
      .then((response) => {
        commit('SET_ACTIVE_SERVICE_PAYMENT', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  report(_, options) {
    return http.v1.sp.report(options);
  },
  reminderEmail(_, oid) {
    return http.v1.sp.reminderEmail(oid);
  },
};

const mutations: MutationTree<ServicePaymentState> = {
  SET_ACTIVE_SERVICE_PAYMENT(state, activeServicePayment) {
    state.activeServicePayment = activeServicePayment;
  },
  SET_PAYMENT_INTENT(state, paymentIntent) {
    state.paymentIntent = paymentIntent;
  },
  CLEAR_STATE(state) {
    state.activeServicePayment = null;
  },
};

const servicePayment: Module<ServicePaymentState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default servicePayment;
